import api from "./api";

export const fetchRequirements = async () => {
  try {
    const res = await api.get("/requirements");
    return res.data;
  } catch (err) {
    console.error("Erreur lors du fetch des requirements :", err);
    throw err;
  }
}; 
export const fetchAspirantsProgress = async (egliseId, parcours) => {
  try {
    const res = await api.get("/aspirants/progress", {
      params: {
        eglise_id: egliseId,
        parcours: parcours
      }
    });
    return res.data; 
  } catch (err) {
    console.error(`Erreur lors du fetch de la progression (${parcours}) :`, err);
    throw err;
  }
};

export const fetchRequirementsByAspirant = async (aspirantId, { parcours, onlyPending = true } = {}) => {
  try {
    const params = new URLSearchParams();
    params.set("aspirant_id", aspirantId);
    if (parcours) params.set("parcours", parcours);
    if (onlyPending) params.set("onlyPending", "1");

    const res = await api.get(`/requirements/by-aspirant?${params.toString()}`);
    return res.data;
  } catch (err) {
    console.error("Erreur fetchRequirementsByAspirant:", err);
    throw err;
  }
};

export const fetchRequirementsByAspirantWithStatus = async (aspirantId, { parcours } = {}) => {
  try {
    const params = new URLSearchParams();
    params.set("aspirant_id", aspirantId);
    if (parcours) params.set("parcours", parcours);

    const res = await api.get(`/requirements/by-aspirant/with-status?${params.toString()}`);
    return res.data;
  } catch (err) {
    console.error("Erreur fetchRequirementsByAspirantWithStatus:", err);
    throw err;
  }
};